import { QueryClientProvider } from "@tanstack/react-query";
import * as React from "react";
import { createQueryClient } from "./src/queryClient";
import "./src/styles/global.css";

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  const queryClient = createQueryClient();
  return (
    <QueryClientProvider client={queryClient}>{element}</QueryClientProvider>
  );
};
